module.exports = __webpack_public_path__ + "media/images/i-20225a3124ca3cd0ec12d92cc1db2570.svg";